import { render } from "./JobManagementClient.vue?vue&type=template&id=2d912a16&scoped=true"
import script from "./JobManagementClient.vue?vue&type=script&lang=js"
export * from "./JobManagementClient.vue?vue&type=script&lang=js"

import "./JobManagementClient.vue?vue&type=style&index=0&id=2d912a16&scoped=true&lang=css"

import exportComponent from "C:\\mgtspl\\mgtspl\\MGTSPL_FE\\MGTSPL\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d912a16"]])

export default __exports__